/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_TitleInputs */



/**
* | output |
* | --- |
* | "Your feedback" |
*
* @param {Practice_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_title = /** @type {((inputs?: Practice_Feedback_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Jouw feedback")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre feedback")
	return /** @type {LocalizedString} */ ("Your feedback")
});